import { render, staticRenderFns } from "./JoinedChange.vue?vue&type=template&id=1ae6deff&"
import script from "./JoinedChange.vue?vue&type=script&lang=js&"
export * from "./JoinedChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports